<template>
  <div class="uploader">

    <div class="uploader-section uploader-top">
      <input type="file"
             class="hidden"
             @change="updateCurrImg" accept="image/*"
             :name="code"
             :ref="code"
             :data-vv-name="code"
             v-validate="(required) ? 'required' : ''">
      <img v-if="dataImg !== null" :alt="code" :src="getdataImg" />
    </div>

    <div class="uploader-section uploader-bottom">
      <label v-if="dataImg !== null" class="remove al-button" @click="removeImage">
        <i class="fas fa-times"></i> Remove Image
      </label>

      <label v-else-if="!uploading" class="upload al-button" @click="$refs[code].click()">
        <i class="fas fa-upload"></i> Upload Image
      </label>

      <label v-if="uploading" class="upload al-button">
        <i class="far fa-clock"></i>Please Wait
      </label>
      <div v-if="errors.has(code)" class="text-danger my-2">{{ errors.first(code).replace(code, 'Image') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    code: {
      type: String
    },
    index: {
      type: Number
    },
    callback: {
      type: Function
    },
    img_id: {
      type: String
    },
    required: {
      type: Boolean
    }
  },
  data () {
    return {
      uploadImg: null,
      dataImg: null,
      uploading: false
    }
  },
  components: {
  },
  mounted () {
    console.log('u i img_id', this.img_id)
    if (this.img_id) {
      this.dataImg = this.img_id
    }
  },
  watch: {
    img_id () {

      this.dataImg = this.img_id
    }
  },
  computed: {
    getdataImg () {
      return `https://restapi.authorizelocal.com/api/posts/photo/${this.dataImg}`
    }
  },
  methods: {
    removeImage () {
      this.dataImg = null
      this.callback('', this.index)
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        //reader.readAsDataURL(input.target.files[0])
        this.uploadImg = input.target.files[0]
        this.uploadImage(this.callback)
      }
    },
    uploadImage (callback) {
      if (this.uploadImg !== null) {
        this.uploading = true
        const img_obj = {
          file: this.uploadImg
        }
        console.log('uploading image', img_obj)
        this.$store.dispatch('uploadImage', img_obj,  event => {
          this.progress = Math.round((100 * event.loaded) / event.total)
        }).then((response) => {
          console.log('upload image', response)
          this.dataImg = response.data.data
          callback(response.data.data, this.index)
          this.$vs.notify({
            title: 'Success',
            text: response.data.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.uploading = false
        }).catch(err => {
          console.log(err)
          this.$vs.notify({
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.uploading = false
        })
      }
    }
  }
}
</script>
<style lang="scss">
.uploader-section {
  margin:20px 0;
}
.uploader-top img {
  max-width:150px;
}
</style>
